import React, {useState} from 'react'

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';

import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/FileCopy';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import Typography from '@mui/material/Typography';
import Input from '@mui/material/Input';

import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import SiteAddressForm from './SiteAddressForm'
import AlertDialog from './AlertDialog'
import ColorButton from './ColorButton'

const CollapsableRow = (props) => {
    const [open, setOpen] = useState(false);
    const [selcopy, setSelCopy] = useState(props.selectedsite)
    const row = props.row
    let colours = {bg: 'white', col: '#000000'}
    if(props.row.site_id == props.selectedsite )
        colours = {bg: 'green', col: '#ffffff'} 
    let checked = ''
    if((props.sitecopyid??props.selectedsite) == props.row.site_id )
        checked='checked'

    return (
        <React.Fragment>
            <TableRow
            key={`main_site_tab_${row.site_id}`}
            style={{backgroundColor: colours.bg}}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
            <TableCell  component="th" scope="row" style={{color: colours.col, fontSize: '12px'}} >
            <IconButton style={{fontSize: '10px'}} aria-label="expand row" size="small" onClick={() => setOpen(!open)} >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>&nbsp;{row.site_id}
            </TableCell>
            <TableCell   style={{color: colours.col, fontSize: '12px'}}>{row.site_name}</TableCell>
            <TableCell  style={{color: colours.col, fontSize: '12px'}} onClick={() => props.changeSite(row.site_id) } >{row.address?.address1 || ''} </TableCell>
            <TableCell  style={{color: colours.col, fontSize: '12px'}}>{row.address?.postcode || ''}</TableCell>
            <TableCell  style={{color: colours.col, fontSize: '12px'}}>{row.contacts?.length ?? 0}</TableCell>
            <TableCell  style={{color: colours.col, fontSize: '12px'}}>
            <IconButton style={{fontSize: '10px'}} size="small"  onClick={() => props.editForm(row.site_id, 'Edit', true) } >
                <EditIcon style={{fontSize: '10px'}} />
            </IconButton>
            <IconButton size="small" style={{fontSize: '10px'}} onClick={() => props.editForm(row.site_id, 'CopyFrom', true) } >
                <ContentCopyIcon  style={{fontSize: '10px'}}  />
            </IconButton>
            <IconButton size="small" style={{fontSize: '10px'}} onClick={() => props.deleteSite(row.site_id)}>
                <DeleteIcon style={{fontSize: '10px'}} />
            </IconButton>
            </TableCell>
        </TableRow>
        <TableRow key={`collaps_row_${row.site_id}`}>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }}>
                <Typography gutterBottom component="div">
                    <strong>Contacts for site {row.site_name}</strong>
                </Typography>
                <Table key={`tab_col_${row.site_id}`} size="small" aria-label="purchases">
                    <ContactHeader fields={["Title","First","Last","Position","Mobile Phone"]} />
                    <TableBody>
                    {(row.contacts || []).map((contact,index) => (
                        <TableRow key={`key_col_${index}`} >
                        <TableCell component="th" scope="row">
                            {contact.title || ''}
                        </TableCell>
                        <TableCell>{contact.first || ''}</TableCell>
                        <TableCell>{contact.last || ''}</TableCell>
                        <TableCell>{contact.position || ''}</TableCell>
                        <TableCell><a href={'tel:' + (contact.mobilephone || '')} >{contact.mobilephone || ''}</a>
                            <IconButton aria-label="expand row" size="small"  >
                                <EditIcon style={{fontSize: '12px'}} />
                            </IconButton>
                        </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
                </Box>
            </Collapse>
            </TableCell>
        </TableRow> 
        </React.Fragment>
        )
}


export  const  CustomerSiteList = (props) =>  {
    const [confirm, setConfirm] = useState(false);
    const [openform, setOpenForm] = useState(false)
    const [type,setType] = useState('Edit')
    const [siteID, setSiteID] = useState(props.selectedsite??false)
    const [siteName, setSiteName] = useState(props.sites?.[0]?.site_name??false)
    const [tmpsiteID, settmpSiteID] = useState(props.selectedsite??false)
    const [dialogtitle,setAlertTitle] = useState('Confirmation Required')
    const [alertText, setAlertText] = useState()
    const [confText, setConfText] = useState()
    const [adclosefnc, setADCloseFnc] = useState(0) // Set the Alert Dialog Close Function
    const [data,setData] = useState(props.sites?.[0]?.address ?? {})
    const [contacts,setContacts] = useState(props.sites?.[0]?.contacts ?? [])
    const [deleteindex,setDeleteIndex] = useState(-1)

    const AlertDialogFunctions = [
        (text)=>{console.log(text)},
        (status)=>{handleConfirm(status)},
        (status)=>{confirmhandleDeleteConfirm(status)}
    ]
    
    const handleChangeSite = (site_id) => { 
        let site_name = props.sites[site_id].site_name
        settmpSiteID(site_id)
        setAlertText(`You are About to Change to Site "${site_name}". By Doing so you will exit from the current Quote and open the one associated with the new Site, or a new Quotation will be created if one does not alraedy exist.`)
        setConfText("Are You Sure you wish to Switch Sites?")
        setADCloseFnc(1)
        setConfirm(true)   
    }

    const editForm = (site_id, type, status) => { 
        var site_name ="New Site Name"
        var tmpdata
        var contacts= []
        var site_title
        var new_site_id = site_id

        if((site_id??-1) < 0) {
            console.log(`site_id??false returned ${(site_id??-1)} `)
            return
        } 

        let site_index = props.sites.findIndex(item => item.site_id == site_id)
        console.log(`site_id ${site_id} site_index ${site_index}`)
        console.log(props.sites)

        var site_name
        if(site_index >= 0)
            site_name = props.sites[site_index].site_name
        if(site_index <0 && type !=='New') return
        switch(type) {
            case 'Edit':
                if(site_id >=0 ) {
                    // Provide default empty address if missing from FLG
                    const defaultAddress = {address1: '', address2: '',address3: '',town: '',
                        county: '',postcode: '',country: '', additionalinfo: ''}
                    tmpdata = {...defaultAddress, ...(props.sites[site_id]?.address || {})}
                    ;(props.sites[site_id]?.contacts || []).map((item)=> {
                        contacts.push(item)
                    })
                    site_title = `Edit "${site_name}" Details`
                }
                break;
            case 'New':
                site_title = 'Create New Site'
                tmpdata = {address1: '', address2: '',address3: '',town: '',
                    county: '',postcode: '',country: '', additionalinfo: ''
                }
                contacts = []; //{id: 0,title: '',first: '',last: '',email: '',mobilephone: '', homephone: '',workphone: '',notes: ''}]
                new_site_id =   Math.max(...props.sites.map(o=>o.site_id))+1
                console.log(`new_site_id set to ${new_site_id}`)
                break;
            case 'CopyFrom':
                if(site_id >=0 ) {
                    const defaultAddress = {address1: '', address2: '',address3: '',town: '',
                        county: '',postcode: '',country: '', additionalinfo: ''}
                    new_site_id =   Math.max(...props.sites.map(o=>o.site_id))+1
                    site_name = `Copy of ${props.sites[site_id]?.site_name || 'Unknown'}`
                    site_title =`Create New Site from Site "${site_name}"`
                    let data = {...props.sites[site_id]}
                    data.site_id = new_site_id
                    data.contacts = data.contacts || []
                    const iLen = data.contacts.length
                    for(let i=0; i<iLen; i++)
                        data.contacts[i].notes = `${data.contacts[i].notes || ''}\n\nCopied from site ${site_name} on ${new Date()}`
                    tmpdata = {...defaultAddress, ...(data.address || {})}
                    contacts = [...data.contacts]
                }
                break;

    
        }
        setSiteID(new_site_id)
        setType(site_title)       
        setSiteName(site_name)
        setData(tmpdata) 
        setContacts(contacts) 
        setOpenForm(status) 
    }

    // Dleete a Site - This will be pushed back down to the Callig Component via onDelete
    const deleteSite = (index) => {
        let site_name= props.sites[index].site_name
        setAlertTitle('*** IMPORTANT CONFIRM DELETE SITE ***')
        setAlertText(`You are About to DELETE the Site named "${site_name}". This will lose ALL of the data associated with this site Including any Quotes Data which will also be LOST!!!`)
        setConfText("Are You SURE you wish to Delete This Site?") 
        setDeleteIndex(index)
        setADCloseFnc(2)
        setConfirm(true)
    }

    // Handle the Alert Dialog confirmation
    const confirmhandleDeleteConfirm = (status) =>{
        if(deleteindex < 0) return
        setConfirm(false) 
        if(status) {
            props.onDelete(deleteindex)
            setDeleteIndex(-1)
        }
    }


    const handleConfirm = (status) => { 
        setConfirm(false) 
        if(status) {
            setSiteID(tmpsiteID)
            props.SelectSite(tmpsiteID)
        }
    }

    const saveCustomerAddressForm = (sitedata) => {
        props.onSave({...sitedata})
    }

    return (   
    <React.Fragment>

    {confirm && <AlertDialog open={(confirm??false) }  okPrompt="Yes" cancelPrompt="No" content={alertText} conftext={confText} onClose={AlertDialogFunctions[adclosefnc??0]}  showclose={true} showopen={true} title={dialogtitle} /> }
    <SiteAddressForm  address={data} site_id={siteID} open={openform} onClose={setOpenForm} onSave={saveCustomerAddressForm} type={type} site_name={siteName} contacts={contacts} /> 
      <TableContainer component="div" >
        <Table size="small" sx={{ width: 560 }} aria-label="simple table">
          <TableHead>
            <TableRow>
                <TableCell style={{borderBottom: 0, fontSize: '12px'}} size="small" >ID</TableCell>
                <TableCell style={{borderBottom: 0, fontSize: '12px'}} size="small">Site Name</TableCell>
                <TableCell style={{borderBottom: 0, fontSize: '12px'}} size="small" >Address1</TableCell>
                <TableCell style={{borderBottom: 0, fontSize: '12px'}} size="small" >Postcode</TableCell>
                <TableCell style={{borderBottom: 0, fontSize: '12px'}} size="small">#</TableCell>
                <TableCell style={{borderBottom: 0, fontSize: '12px'}} size="small"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(props.sites??[]).map((row,index) => { 
                return (<CollapsableRow 
                            key={`CR${index}`} row={row} 
                            changeSite={handleChangeSite} 
                            selectedsite={props.selectedsite}
                            changeSelCopy={props.changeSelCopy}
                            sitecopyid={props.sitecopyid}
                            editForm={editForm}
                            deleteSite={deleteSite}

                        />)
            })}
            <TableRow>
                <TableCell size="small" colSpan={6} align="right">
                    <ColorButton  style={{fontSize: '12px'}} onClick={()=>console.log('ButtonClicked',editForm(siteID, 'New', true))}>Add New Site</ColorButton> 
                </TableCell>
            </TableRow>
            </TableBody>
        </Table>
      </TableContainer>
     
    </React.Fragment>
    );
  }

const ContactHeader = (props) => {
    return (
        <TableHead>
            <TableRow>
                {(props.fields??[]).map((item,index) => {
                    return (<TableCell key={`chead_${index}` }>{item}</TableCell> )
                })}
            </TableRow>
        </TableHead>
    )
}

export default CustomerSiteList